<!--
 * =====================================================================
 * 작 업 명  : 회원가입
 * 파 일 명  : Join.vue
 * 변경이력 
 * 2022-01-29 / 정태화 / 최초작성
 * 2022.02-15 / 경다찬 / 메일 발송, 수신 코드, ID 중복체크 작성
 * =====================================================================
 -->
<template>
  <div>
    <Join1
      v-show="showJoin1"
      :user="user"
      :fromParams="fromParams"
      @changeData="changeData"
    >
    </Join1>

    <Join2
      v-show="showJoin2"
      :user="user"
      :fromParams="fromParams"
      @prev="prev"
      @changeData="changeData"
      ref="join2"
    >
    </Join2>

    <Join3
      v-show="showJoin3"
      :user="user"
      :fromParams="fromParams"
      @prev="prev"
      @changeData="changeData"
    >
    </Join3>

    <Join4 v-show="showJoin4" :fromParams="fromParams"> </Join4>
  </div>
</template>
<script>
import { $global } from "@/dot-ui/index.js";
import Join1 from "@/components/user/Join1.vue";
import Join2 from "@/components/user/Join2.vue";
import Join3 from "@/components/user/Join3.vue";
import Join4 from "@/components/user/Join4.vue";

export default {
  data() {
    return {
      user: {
        FIRST_NAME: "",
        LAST_NAME: "",
        EMAIL: "",
        USER_CODE: "",
        USER_ID: "",
        PASSWORD: "",
        PASSWORD2: "",
        NICK_NAME: "",
        SEX_TYPE: "",
        USER_TYPE: "",
        MOBILE: "",
        TEL: "",
        BIRTH_DAY: "",
        BIRTH_TYPE: "",
        ADDR1: "",
        ADDR2: "",
        AREA: "",
        ZIP_CODE: "",
      },
      fromParams: "",
      showJoin1: true,
      showJoin2: false,
      showJoin3: false,
      showJoin4: false,
    };
  },
  components: {
    Join1,
    Join2,
    Join3,
    Join4,
  },
  created() {
    this.fromParams = $global.getUrlParams();
  },
  methods: {
    changeData(user, stage) {
      this.user = user;

      if (stage === "showJoin2") {
        this.$refs.join2.sendCode();
      }

      this.onShow(stage);
    },
    prev(user, stage) {
      this.user = user;
      this.onShow(stage);
    },
    onShow(selectedView) {
      this.showJoin1 = false;
      this.showJoin2 = false;
      this.showJoin3 = false;
      this.showJoin4 = false;

      if (selectedView === "showJoin1") {
        this.showJoin1 = true;
      }

      if (selectedView === "showJoin2") {
        this.showJoin2 = true;
      }

      if (selectedView === "showJoin3") {
        this.showJoin3 = true;
      }

      if (selectedView === "showJoin4") {
        this.showJoin4 = true;
      }
    },
  },
};
</script>
<style></style>
